import React from 'react';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { ProgressSpinner } from 'primereact/progressspinner';

import ShowcaseCard from '../../components/ShowcaseCard';

export default function Featured({data, isLoading, error}) {
    const navigate = useNavigate();

    return (
        <>
            <h2 className='title'>Featured Projects</h2>
            {isLoading && (
                <div className='flex justify-content-center py-4'>
                    <ProgressSpinner style={{ width: '3rem', height: '3rem' }} strokeWidth='8' />
                </div>
            )}
            {!isLoading && error && <p className='gray'>{error}</p>}
            {!isLoading && !error && data.map((event) => (
                <ShowcaseCard key={event.id ?? event.name} data={event} />
            ))}
            <div className='flex justify-content-center lg:justify-content-end'>
                <Button
                    label="View All Projects"
                    icon="pi pi-bars"
                    rounded
                    onClick={() => navigate('/projects/')}
                    size='small'
                />
            </div>
        </>
    );
}
